import * as React from 'react';
import SelectMUI, { SelectProps } from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import cn from 'classnames';

import './Select.css';

export interface Item {
	value: string;
	label: string;
}

interface Props {
	items?: Item[];
	label: string;
	disabled?: boolean;
	rootClassName?: string;
	formClassName?: string;
}

const Select: React.FunctionComponent<SelectProps & Props> = ({ items, label, formClassName, rootClassName, ...selectProps }) => {
	return (
		<FormControl
			fullWidth={true}
			classes={{
				root: formClassName
			}}
		>
			<InputLabel id={selectProps.name} variant="filled">
				{label}
			</InputLabel>

			<SelectMUI
				{...selectProps}
				labelId={selectProps.name}
				fullWidth={true}
				variant="filled"
				disableUnderline={true}
				classes={{
					root: cn("select", rootClassName),
				}}
			>
				{items.map((option) => {
					return !selectProps.native ?
						<MenuItem value={option.value} key={option.value}>
							{option.label}
						</MenuItem>
						: <option value={option.value}>
							{option.label}
					</option>
				})}
			</SelectMUI>
		</FormControl>
	);
};

export default Select;
